export const SIGN_IN = 'auth' // POST + { "username": "string", "password": "string" }
export const GET_ALL_OFFER = 'get-offers' // GET
export const GET_ALL_STREAM = 'get-streams' // GET
export const CREATE_STREAM = 'add-streams' // POST
export const LOGOUT = 'get-streams' // GET
export const GET_USER = 'get-user' // GET
export const CHANGE_STREAM_NAME = 'change-stream-name' // GET
